import fetch from 'isomorphic-unfetch';

import { apiHeaders } from '../generic';

export default class AddWorkApis {
  static getCategories = async () => {
    const url = `${process.env.MARKETPLACE_API_URL}api/v1/master_data/categories/search`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify({})
    });

    return res;
  };

  static getObjectiveById = async (id) => {
    const url = `${process.env.MARKETPLACE_API_URL}api/v1/master_data/campaign_objectives/${id}`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'GET',
      headers
    });

    return res;
  };

  static getObjectives = async (data) => {
    const reqBody = data;
    const url = `${process.env.MARKETPLACE_API_URL}api/v1/master_data/campaign_objectives/search`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(reqBody)
    });

    return res;
  };

  static createRequirement = async (data) => {
    const reqBody = data;
    const url = `${process.env.MARKETPLACE_API_URL}api/v1/clients/work_requirements/create`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'POST',
      headers,
      body: JSON.stringify(reqBody)
    });

    return res;
  };

  static updateRequirement = async (id, data) => {
    const reqBody = data;
    const url = `${process.env.MARKETPLACE_API_URL}api/v1/clients/work_requirements/${id}/update`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'PATCH',
      headers,
      body: JSON.stringify(reqBody)
    });

    return res;
  };

  static updateRequirementStatus = async (id, event) => {
    const url = `${process.env.MARKETPLACE_API_URL}api/v1/clients/work_requirements/${id}/status_update/${event}`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'PATCH',
      headers,
      body: JSON.stringify({})
    });

    return res;
  };

  static getRequirement = async (id) => {
    const url = `${process.env.MARKETPLACE_API_URL}api/v1/clients/work_requirements/${id}`;
    const headers = apiHeaders();
    const res = await fetch(url, {
      method: 'GET',
      headers
    });

    return res;
  };
}
